import React from "react";
import { ArrowUpRight, TrendingUp, TrendingDown } from "lucide-react";

const TONE_CLASS = {
  positive: "bg-emerald-50 border-emerald-200 text-emerald-700",
  negative: "bg-red-50 border-red-200 text-red-700",
  warning: "bg-amber-50 border-amber-200 text-amber-700",
};

export function StatsBadge({ badge, testid }) {
  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-[11px] font-semibold ${TONE_CLASS[badge.tone] || TONE_CLASS.warning}`}
      data-testid={testid}
    >
      <span>{badge.icon}</span>
      <span>{badge.label}</span>
      <span className="font-normal opacity-80 hidden sm:inline">— {badge.detail}</span>
    </div>
  );
}

export function StatsKpiCard({ label, value, unit, sub, icon: Icon, variation, variationSuffix = "%", accent = "violet", onClick, badge, testid }) {
  const hasVar = typeof variation === "number" && variation !== 0;
  const up = hasVar && variation > 0;
  const ACCENTS = {
    violet: "bg-violet-50 text-violet-600",
    emerald: "bg-emerald-50 text-emerald-600",
    sky: "bg-sky-50 text-sky-600",
    amber: "bg-amber-50 text-amber-600",
    red: "bg-red-50 text-red-600",
    slate: "bg-slate-100 text-slate-500",
  };
  return (
    <button
      onClick={onClick}
      className="group relative text-left rounded-2xl bg-white border border-slate-200 p-4 hover:border-violet-300 hover:shadow-[0_4px_20px_-6px_rgba(124,58,237,0.18)] transition-all duration-200 w-full"
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <span className={`h-8 w-8 rounded-lg flex items-center justify-center ${ACCENTS[accent] || ACCENTS.violet}`}>
          {Icon && <Icon className="h-4 w-4" />}
        </span>
        <ArrowUpRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-violet-500 transition-colors" />
      </div>
      <div className="mt-3 flex items-baseline gap-1.5 flex-wrap">
        <span className="font-heading text-2xl font-bold text-slate-900 tabular-nums">{value}</span>
        {unit && <span className="text-xs font-semibold text-slate-400">{unit}</span>}
        {hasVar && (
          <span className={`inline-flex items-center gap-0.5 text-[11px] font-bold ${up ? "text-emerald-600" : "text-red-500"}`}>
            {up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
            {up ? "+" : ""}{variation}{variationSuffix}
          </span>
        )}
      </div>
      <div className="mt-0.5 text-[11px] font-medium text-slate-500">{label}</div>
      {sub && <div className="text-[10px] text-slate-400">{sub}</div>}
      {badge && (
        <div className="mt-2">
          <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-semibold ${TONE_CLASS[badge.tone] || TONE_CLASS.warning}`}>
            {badge.icon} {badge.label}
          </span>
        </div>
      )}
    </button>
  );
}
